import { render, staticRenderFns } from "./waitingProcess.vue?vue&type=template&id=087e61e9&scoped=true&"
import script from "./waitingProcess.vue?vue&type=script&lang=ts&"
export * from "./waitingProcess.vue?vue&type=script&lang=ts&"
import style0 from "./waitingProcess.vue?vue&type=style&index=0&id=087e61e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e61e9",
  null
  
)

export default component.exports